import { Cancel01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { Badge, BadgeSize, BadgeVariant } from "shared/components";
import { cx } from "shared/utils";

/** A plain grey tag pill. Long names are shortened with an ellipsis. */
export const LeadTagPill = ({
  name,
  onRemove,
  className
}: {
  name: string;
  onRemove?: () => void;
  className?: string;
}) => (
  <Badge
    variant={BadgeVariant.BASE}
    size={BadgeSize.SM}
    borderless={false}
    className={cx("max-w-[124px] items-center", className)}
    rightElement={
      onRemove ? (
        <button
          type="button"
          aria-label={`Remove tag ${name}`}
          className="shrink-0 text-content-400 hover:text-content-1000"
          onClick={(event) => {
            event.stopPropagation();
            onRemove();
          }}
        >
          <HugeiconsIcon icon={Cancel01Icon} size={12} strokeWidth={2.4} />
        </button>
      ) : null
    }
  >
    <span className="truncate">{name}</span>
  </Badge>
);
